<template>
  <div class="image-uploader">
    <!-- 已有图片显示 -->
    <div v-if="displayUrl" class="image-wrapper" :style="wrapStyle">
      <img :src="displayUrl" class="preview-img" @click="handlePreview" />
      <div class="image-actions" v-if="!disabled">
        <button class="btn-icon btn-delete" title="移除图片" @click="handleRemove">
          <el-icon><Delete /></el-icon>
        </button>
      </div>
    </div>
    <!-- 上传区域 -->
    <el-upload
      v-if="!displayUrl && !disabled"
      :action="uploadUrl"
      name="file"
      :show-file-list="false"
      :on-success="handleSuccess"
      :on-error="handleError"
      :before-upload="beforeUpload"
      accept="image/jpeg,image/png,image/gif,image/bmp"
      drag
    >
      <div class="upload-area" :style="wrapStyle">
        <el-icon class="upload-icon"><Plus /></el-icon>
        <div class="upload-text">点击或拖拽上传</div>
        <div class="upload-tip">jpg/png/gif/bmp, 不超过2MB</div>
      </div>
    </el-upload>

    <!-- 图片预览弹窗 -->
    <el-dialog v-model="previewVisible" title="图片预览" width="600px">
      <img :src="previewUrl" style="width: 100%" />
    </el-dialog>
  </div>
</template>

<script>
import { Plus, Delete } from '@element-plus/icons-vue'
import { resolveImageUrl } from '@/utils/imageUrl'

export default {
  name: 'ImageUploader',
  components: { Plus, Delete },
  props: {
    // 上传目标目录：products | signatures | logos
    target: { type: String, default: 'products' },
    modelValue: { type: String, default: '' },
    width: { type: [Number, String], default: 200 },
    height: { type: [Number, String], default: 200 },
    disabled: { type: Boolean, default: false }
  },
  emits: ['update:modelValue', 'uploaded'],
  data() {
    return {
      previewVisible: false,
      previewUrl: ''
    }
  },
  computed: {
    uploadUrl() {
      return `/apiserve/crmapi/product_upload.asp?target=${this.target}`
    },
    displayUrl() {
      return resolveImageUrl(this.modelValue)
    },
    wrapStyle() {
      const w = Number(this.width) || 200
      const h = Number(this.height) || 200
      return { width: w + 'px', height: h + 'px' }
    }
  },
  methods: {
    beforeUpload(file) {
      const isImage = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp'].includes(file.type)
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isImage) {
        this.$message.error('只能上传图片文件!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB!')
        return false
      }
      return true
    },
    handleSuccess(response) {
      if (response.success) {
        this.$emit('update:modelValue', response.url)
        this.$emit('uploaded', response.url)
        this.$message.success('上传成功')
      } else {
        this.$message.error(response.message || '上传失败')
      }
    },
    handleError() {
      this.$message.error('上传失败，请重试')
    },
    handleRemove() {
      this.$emit('update:modelValue', '')
      this.$emit('uploaded', '')
    },
    handlePreview() {
      this.previewUrl = this.displayUrl
      this.previewVisible = true
    }
  }
}
</script>

<style scoped>
.image-wrapper {
  position: relative;
  display: inline-block;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  overflow: hidden;
}
.preview-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #f5f7fa;
  cursor: pointer;
}
.image-actions {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  gap: 4px;
  padding: 4px;
  opacity: 0;
  transition: opacity 0.2s;
}
.image-wrapper:hover .image-actions {
  opacity: 1;
}
.btn-icon {
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 14px;
}
.btn-delete {
  background: #f56c6c;
  color: #fff;
}
.btn-delete:hover {
  background: #e64550;
}
.upload-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}
.upload-icon {
  font-size: 32px;
  color: #c0c4cc;
  margin-bottom: 8px;
}
.upload-text {
  font-size: 13px;
  color: #606266;
}
.upload-tip {
  font-size: 11px;
  color: #909399;
  margin-top: 4px;
}
</style>
